<template>
  <div v-bind:class="{'wizard-step': true, 'active': isActive, 'previous' : isPrevious, 'next' : isNext}" v-on:click.prevent="changeCurrentIndex()">
  <div class="wizard-progress">
    <div class="wizard-progress-value"></div>
  </div>
  <div class="wizard-icon">
    <div class="icon-icon"><span class="info-box-icon"><i class="fa fa-{{icon}} fa-1x"></i></span></div>
    <div class="icon-number" v-if="!icon">{{iconNumber || index +1}}</div>
  </div>
  <div class="wizard-content">
    <div class="title">{{title}}</div>
    <div class="description">{{description}}</div>
  </div>
  <div class="step-info">
    Stap {{index+1}}/{{$parent.countItems}}
  </div>
</div>
</template>

<script>
import './wizard.css'
export default {
  replace: true,
  data () {
    return {
      index: null,
      active: false
    }
  },
  computed: {
    isActive () {
      return (this.$parent.currentIndex === this.index)
    },
    isPrevious () {
      // every step before current index
      return this.$parent.currentIndex > this.index
    },
    isNext () {
      // everything after current index
      return this.$parent.currentIndex < this.index
    }
  },
  props: {
    link: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: false
    },
    iconNumber: {
      type: String,
      default: false
    },
    title: {
      type: String,
      default: false
    },
    description: {
      type: String,
      default: false
    },
    progress: {
      type: Number
    },
    valid: {
      type: Boolean,
      default: false
    },
    disablePrevious: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeCurrentIndex () {
      if (this.$parent.changeCurrentIndex(this.index) && this.link) {
        // redirect user to the new location
        this.changeLocation(this.$router, this.link)
      }
    },
    changeLocation (router, link) {
      if (!link) return
      if (router) {
        router.go(link)
      } else {
        window.location.href = link
      }
    }
  },
  watch: {
    progress (val) {
      this._progressBar.style.width = val + '%'
      if (val === 100) {
        this.valid = true
      } else {
        this.valid = false
      }
    },
    valid (val) {
      if (val) {
        this.progress = 100
      }
    }
  },
  components: {
  },
  ready () {
    this._progressBar = this.$el.querySelector('.wizard-progress-value')
  }
}
</script>


// WEBPACK FOOTER //
// wizard-step.vue?1d004ca9